import { render, staticRenderFns } from "./OnboardingView.vue?vue&type=template&id=c8b9d67a&scoped=true"
import script from "./OnboardingView.vue?vue&type=script&lang=js"
export * from "./OnboardingView.vue?vue&type=script&lang=js"
import style0 from "./OnboardingView.vue?vue&type=style&index=0&id=c8b9d67a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b9d67a",
  null
  
)

export default component.exports